import react from "react";

import './Form.css';

const InputSearch = ({ 
                label = "",
                value = "",
                predicts = [],
                onChangePredict,
                isSelected = false,
                className = "form-control form-input",
                ...props
                
            }
) => {
    let randForId = "field-" + Math.random(0, 9999);

    const DropdownPredicts = (props) => {
        //if (predicts.length > 0 && value.length > 0) {
        if (isSelected) {
            const Options = () => {
                return predicts.map((item, index) => {
                    return (
                        <li key={index} onClick={() => onChangePredict(item)}>
                            <div>
                                {item.name}
                            </div>

                            <div className="option-description">
                                {item.description}
                            </div>
                        </li>
                    )
                })
            }

            return (
                <div className="InputSearch-predictsBox">
                    <ul>
                        <Options />
                    </ul>
                </div>
            )
        }
        return null;
    }

    return (
        <div>
            <label htmlFor={randForId} className="form-label">{label}</label>
            <input value={value === null ? '' : value} id={randForId} autoComplete="off" className={className} {...props} />
            <DropdownPredicts />

        </div>
    )
}


export default InputSearch;